import React, { useEffect, useState } from "react";
import Footer from "../components/Footer";
import { IoIosMenu, IoIosCart, IoIosHeart } from "react-icons/io";
import { FaTruck, FaMedal } from "react-icons/fa";
import { GiHoneyJar } from "react-icons/gi";
import { MdSupportAgent, MdShoppingCart } from "react-icons/md";
import { FiPhone, FiSend } from "react-icons/fi";
import { BiUserCircle } from "react-icons/bi";
import { FaQuoteLeft, FaBars, FaWhatsapp } from "react-icons/fa";
import axios, { AxiosError } from 'axios';
import { apiClient } from '../config/apiConfig';
import { getAuthenticatedCustomerName } from '../utils/auth';
import CustomerAuthActions from "../components/CustomerAuthActions";
import Search from "../components/Search";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "../styles/ProductCard.css";



interface Variant {
  variantId: number;
  weight: number;
  unit: string; // "g" or "kg"
  price: number;
  stock: number;
}
interface Category {
  CategorieId: number;
  Name: string;
  ImageUrl: string | null;
  slug?: string;
}

interface Product {
  productId: number;
  productName: string;
  productPrice: number;
  productQuantity: number;
  productDescription?: string;
  productImage?: string;
  variants: Variant[];
  quantity: number;
  variant: string; // selected variant name like "200g"
  cartQuantity: number;
  inCart?: boolean;
}
interface CartItem {
  cartItemsId: number;
  cartId: number;
  productId: number;
  productName: string;
  productImage: string;
  variantId?: number;
  variantName?: string;
  productPrice: number;
  quantity: number;
}
interface Deal {
  id: number;
  title: string;
  description: string;
  products: {
    id: number;
    name: string;
    price: number;
  }[];
  dealPrice: number;
  originalPrice: number;
  savings: number;
  endTime: string;
}

const baseURL = "https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net";

// Toggle to show/hide the "Our satisfied customer says" testimonials section
const SHOW_TESTIMONIALS = false;

const Home: React.FC = () => {
  const [products, setProducts] = useState<Product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);
  const [cartId, setCartId] = useState<number | null>(
    localStorage.getItem("cartId") ? Number(localStorage.getItem("cartId")) : null
  );
  const [customerName, setCustomerName] = useState<string | null>(null);
  useEffect(() => {
    setCustomerName(getAuthenticatedCustomerName());
  }, []);
  const [searchTerm, setSearchTerm] = useState("");

  const [searchParams, setSearchParams] = useSearchParams();
  const queryParam = searchParams.get("query") || "";
  const navigate = useNavigate();
  const [categories, setCategories] = useState<Category[]>([]);
  const [cartItems, setCartItems] = useState<CartItem[]>([]);
  const [testimonials, setTestimonials] = useState<any[]>([]);
  const [selectedImage, setSelectedImage] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);


  // Load external script once - only if it doesn't initialize carousels
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.src = "/js/main.js";
    script.async = true;
    script.onerror = (err) => {
      console.warn("Failed to load main.js:", err);
    };
    document.body.appendChild(script);
    return () => {
      try {
        if (script && document.body.contains(script)) {
          document.body.removeChild(script);
        }
      } catch (e) {
        console.warn("Error removing script:", e);
      }
    };
  }, []);

  // Fetch products
  const fetchProducts = async (searchQuery?: string) => {
    try {
      const url = searchQuery
        ? `https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/AddProduct/GetAllProducts?query=${encodeURIComponent(
          searchQuery
        )}`
        : `https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/AddProduct/GetAllProducts`;

      const res = await fetch(url);
      if (!res.ok) throw new Error("Failed to fetch products");
      const data: Product[] = await res.json();

      // Initialize quantity & variant
      const initialized = data.map((p) => ({
        ...p,
        quantity: 1,
        variant:
          p.variants.length > 0
            ? `${p.variants[0].weight}${p.variants[0].unit}`
            : "100g",
        cartQuantity: 0,
        inCart: false,
      }));

      setProducts(initialized);
      setFilteredProducts(initialized);
    } catch (err) {
      console.error("Error fetching products:", err);
      toast.error("Failed to fetch products");
    }
  };
  const fetchCategories = async () => {
    try {
      const res = await fetch("https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/Categories/GetCategories");
      if (!res.ok) throw new Error("Failed to fetch categories");
      const data: Category[] = await res.json();
      setCategories(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
      toast.error("Failed to load categories");
    }
  };

  const fetchTestimonials = async () => {
    try {
      const res = await fetch("https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/Testimonials/GetTestimonials");
      if (!res.ok) throw new Error("Failed to fetch testimonials");
      const data = await res.json();
      setTestimonials(data);
    } catch (error) {
      console.error("Error fetching testimonials:", error);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchTestimonials();
  }, []);

  // Fetch with query
  useEffect(() => {
    const loadData = async () => {
      await fetchProducts(queryParam);
      await fetchCart();
    };

    loadData();
  }, [queryParam]);

  // Search handler
  // Search handler

  const handleSearch = (searchQuery: string) => {
    if (searchQuery.trim() !== "") {
      navigate(`/shop?query=${encodeURIComponent(searchQuery)}`);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    handleSearch(searchTerm);
  };

  // ✅ Add to Cart
  const handleAddToCart = async (product: Product): Promise<boolean> => {
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) {
        toast.warning("Please login to continue.");
        navigate("/login");
        return false;
      }

      const selectedVariant =
        product.variants.length > 0
          ? product.variants.find(v => `${v.weight}${v.unit}` === product.variant)
          : null;

      const cartItemData = {
        customerId: Number(customerId),
        productId: product.productId,
        variantId: selectedVariant?.variantId ?? null,
        priceAtPurchase: selectedVariant?.price ?? product.productPrice,
        quantity: product.quantity || 1,
      };

      const response = await apiClient.post(
        "/Cart/CreateOrAddCartItem",
        cartItemData
      );

      if (response.status === 200) {
        const { cartId } = response.data;
        if (cartId) {
          setCartId(cartId);
          localStorage.setItem("cartId", cartId.toString());
        }

        // ✅ Refresh cart from backend to get actual cartItemsId
        await fetchCart();

        // ✅ Update product UI to show in cart
        setFilteredProducts((prev) =>
          prev.map((p) =>
            p.productId === product.productId
              ? {
                ...p,
                inCart: true,
                quantity: 1,
              }
              : p
          )
        );

        toast.success(
          `${product.quantity} × ${product.productName} (${product.variant}) added to cart!`
        );
        return true;
      }
      return false;
    } catch (error: any) {
      console.error(
        "Error adding to cart:",
        error.response?.data || error.message
      );
      toast.error("Failed to add product to cart");
      return false;
    }
  };
  const fetchCart = async () => {
    try {
      const customerId = localStorage.getItem("customerId");
      if (!customerId) return;

      const response = await apiClient.get(
        `/Cart/GetCartByCustomerId?customerId=${customerId}`
      );

      const items = response.data.items || [];
      setCartItems(items);

      // ✅ Sync Home product quantity with cart
      setFilteredProducts((prev) =>
        prev.map((product) => {
          const cartItem = items.find(
            (c: any) => c.productId === product.productId
          );

          if (cartItem) {
            return {
              ...product,
              inCart: true,
              quantity: cartItem.quantity,
            };
          }

          return {
            ...product,
            inCart: false,
            quantity: 1,
          };
        })
      );

    } catch (error) {
      console.error("Error fetching cart:", error);
    }
  };

  useEffect(() => {
    fetchCart();
  }, []);
  const handleIncrease = async (item: CartItem) => {
    try {
      const updatedCart = cartItems.map((i) =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: i.quantity + 1 }
          : i
      );
      setCartItems(updatedCart);

      // Optional: update quantity in backend
      await apiClient.put(`/Cart/UpdateQuantity`, {
        CartItemsId: item.cartItemsId,
        Quantity: item.quantity + 1,
      });
    } catch (error: any) {
      console.error("Error increasing quantity:", error.response?.data || error.message);
      toast.error("Failed to update quantity");
    }
  };

  const handleDecrease = async (item: CartItem) => {
    if (item.quantity <= 1) return; // prevent 0 quantity
    try {
      const updatedCart = cartItems.map((i) =>
        i.cartItemsId === item.cartItemsId
          ? { ...i, quantity: i.quantity - 1 }
          : i
      );
      setCartItems(updatedCart);

      // Optional: update quantity in backend
      await apiClient.put(`/Cart/UpdateQuantity`, {
        CartItemsId: item.cartItemsId,
        Quantity: item.quantity - 1,
      });
    } catch (error: any) {
      console.error("Error decreasing quantity:", error.response?.data || error.message);
      toast.error("Failed to update quantity");
    }
  };
  const totalCount = cartItems.length;
  const DealTimer: React.FC<{ endDate: string }> = ({ endDate }) => {
    const [time, setTime] = useState("");

    useEffect(() => {
      const timer = setInterval(() => {
        const diff = new Date(endDate).getTime() - new Date().getTime();

        if (diff <= 0) {
          setTime("Expired");
          clearInterval(timer);
          return;
        }

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);
        const s = Math.floor((diff / 1000) % 60);

        setTime(`${d}d ${h}h ${m}m ${s}s`);
      }, 1000);

      return () => clearInterval(timer);
    }, [endDate]);

    return <strong className="text-danger">{time}</strong>;
  };
  const [deals, setDeals] = useState<Deal[]>([]);
  const [email, setEmail] = useState("");

  useEffect(() => {
    fetchDeals();
  }, []);

  const fetchDeals = () => {
    axios
      .get("https://fhome-web-api-dev-cpefddczabfqcmhn.canadacentral-01.azurewebsites.net/DealoftheDay/GetAllDeals")
      .then(res => {
        const mappedDeals: Deal[] = res.data.map((d: any) => ({
          id: d.id,
          title: d.title,
          description: d.description,
          dealPrice: d.dealPrice,
          originalPrice: d.originalPrice,
          savings: d.savings,
          endTime: d.endTime,
          products: d.products
        }));

        setDeals(mappedDeals);
      })
      .catch(err => {
        console.error("Fetch deals failed", err);
      });
  };
  const handleSubscribe = async (e: React.FormEvent) => {
    e.preventDefault();

    // Validate email
    if (!email.trim()) {
      toast.error("Please enter a valid email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    try {
      const response = await apiClient.post(
        "/Newsletter/CreateSubscriber",
        { email: email }
      );

      if (response.status === 200 || response.status === 201) {
        toast.success("Successfully subscribed to our newsletter!");
        setEmail("");
      }

    } catch (error: any) {
      console.error("Error subscribing to newsletter:", error);

      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else if (error.response?.status === 400) {
        toast.error("This email is already subscribed");
      } else {
        toast.error("Failed to subscribe. Please try again later");
      }
    }
  };

  const handleDealBuyNow = async (deal: Deal) => {
    // Check if user is logged in
    const customerId = localStorage.getItem("customerId");
    if (!customerId) {
      toast.warning("Please login or register to continue.");
      navigate("/registration");
      return;
    }

    try {
      let anyAdded = false;

      for (const p of deal.products) {
        // Get full product details to find variants
        const fullProduct = products.find(prod => prod.productId === p.id);

        const dealProduct: Product = {
          productId: p.id,
          productName: p.name,
          productPrice: p.price,
          productQuantity: 1,
          quantity: 1,
          productDescription: fullProduct?.productDescription || "",
          productImage: fullProduct?.productImage || "",
          variants: fullProduct?.variants || [],
          variant: fullProduct?.variants && fullProduct.variants.length > 0
            ? `${fullProduct.variants[0].weight}${fullProduct.variants[0].unit}`
            : "",
          cartQuantity: 1,
          inCart: false
        };

        const added = await handleAddToCart(dealProduct);
        if (added) {
          anyAdded = true;
        }
      }

      if (anyAdded) {
        toast.success("Deal products added to cart!");
        navigate("/cart");
      }
    } catch (error) {
      console.error("Error adding deal products to cart:", error);
      toast.error("Failed to add deal products to cart");
    }
  };
  const updateProductQuantity = async (
    product: Product,
    newQty: number
  ) => {
    if (newQty < 1) return;

    // UI update
    setFilteredProducts(prev =>
      prev.map(p =>
        p.productId === product.productId
          ? { ...p, quantity: newQty }
          : p
      )
    );

    try {
      const cartItem = cartItems.find(
        c => c.productId === product.productId &&
          c.variantId === (product.variants.find(v => `${v.weight}${v.unit}` === product.variant)?.variantId || 0)
      );

      if (!cartItem) {
        console.warn("Cart item not found for product:", product.productId, "variant:", product.variant);
        console.log("Available cart items:", cartItems);
        return;
      }

      console.log("Updating quantity with data:", {
        CartItemsId: cartItem.cartItemsId,
        Quantity: newQty
      });

      // ✅ backend update
      await apiClient.put(
        "/Cart/UpdateQuantity",
        {
          CartItemsId: cartItem.cartItemsId,
          Quantity: newQty
        }
      );

      // local cart sync
      setCartItems(prev =>
        prev.map(c =>
          c.cartItemsId === cartItem.cartItemsId
            ? { ...c, quantity: newQty }
            : c
        )
      );

    } catch (err: any) {
      console.error("Quantity update failed - Full Error:", err.response?.data || err.message);
      console.error("Error details:", {
        status: err.response?.status,
        errors: err.response?.data?.errors,
        message: err.response?.data?.message
      });
      toast.error(`Quantity update failed: ${err.response?.data?.errors ? JSON.stringify(err.response.data.errors) : err.message}`);
    }
  };
  return (
    <div className="goto-here">
      {/* Top Bar */}
      <div className="py-1 bg-primary w-100">
        <div className="container">
          <div className="row d-flex align-items-center text-white">
            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiPhone size={14} className="mr-2" />
              <span>+91 9148761750</span>
            </div>

            <div className="col-12 col-md d-flex align-items-center mb-1 mb-md-0">
              <FiSend size={14} className="mr-2" />
              <span>care@fhome.shop</span>
            </div>

            <div className="col-12 col-md text-md-right">
              <span>3-5 Business days delivery & Free Returns</span>
            </div>
          </div>
        </div>
      </div>

      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark ftco_navbar bg-dark ftco-navbar-light" id="ftco-navbar">
        <div className="container">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img
              src="/images/fhome-logo.jpg"
              alt=""
              style={{ height: "55px", marginRight: "8px", borderRadius: "50%", width: "80px" }}
            />
            <span style={{ fontWeight: 'bold', fontSize: '20px', color: '#28a745' }}></span>
          </a>
          <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#ftco-nav" aria-controls="ftco-nav" aria-expanded="false" aria-label="Toggle navigation">
            <FaBars className="mr-2" /> Menu
          </button>

          <div className="collapse navbar-collapse" id="ftco-nav">
            <ul className="navbar-nav ml-auto align-items-center">

              <li className="nav-item active"><a href="/" className="nav-link">Home</a></li>

              <li className="nav-item dropdown">
                <a className="nav-link dropdown-toggle" href="#" id="dropdown04" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Shop</a>
                <div className="dropdown-menu" aria-labelledby="dropdown04">
                  <a className="dropdown-item" href="/shop">Shop</a>
                </div>
              </li>

              <li className="nav-item"><a href="/about" className="nav-link">About</a></li>
              <li className="nav-item"><a href="/contact" className="nav-link">Contact</a></li>

              {/* 🔥 Search as a list item - neatly aligned */}
              <li className="nav-item mx-2" style={{ width: "200px" }}>
                <Search onSearchResults={handleSearch} />
              </li>

              <li className="nav-item cta cta-colored"> <a href="/cart" className="nav-link">
                <span><MdShoppingCart size={18} /></span> [{totalCount}]
              </a></li>

              <CustomerAuthActions customerName={customerName} />
            </ul>
          </div>
        </div>
      </nav>
      {/* Hero Section */}
      <section id="home-section" className="hero">
        <div className="home-slider owl-carousel">
          <div className="slider-item">
            <div className="slide-bg-blur" style={{ backgroundImage: `url('/images/fhome-honey-pour.jpg')` }}></div>
            <img src="/images/fhome-honey-pour.jpg" alt="F.home honey being poured into a jar" className="slide-photo" />
            <div className="overlay"></div>
            <div className="container">
              <div className="row slider-text justify-content-center align-items-center" data-scrollax-parent="true">
                <div className="col-md-12 ftco-animate text-center">
                  <h1 className="mb-2">We Serve Pure, Traditional Foods</h1>
                  <h2 className="subheading mb-4">Farm-fresh ghee, honey &amp; natural foods, delivered</h2>
                  <p><a href="/about" className="btn btn-primary">View Details</a></p>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-item">
            <div className="slide-bg-blur" style={{ backgroundImage: `url('/images/fhome-ghee-grass.jpg')` }}></div>
            <img src="/images/fhome-ghee-grass.jpg" alt="F.home cow ghee jar" className="slide-photo" />
            <div className="overlay"></div>
            <div className="container">
              <div className="row slider-text justify-content-center align-items-center" data-scrollax-parent="true">
                <div className="col-sm-12 ftco-animate text-center">
                  <h1 className="mb-2">100% Fresh &amp; Natural Foods</h1>
                  <h2 className="subheading mb-4">Traditionally made ghee, honey &amp; dry fruits</h2>
                  <p><a href="/about" className="btn btn-primary">View Details</a></p>
                </div>
              </div>
            </div>
          </div>
          <div className="slider-item">
            <div className="slide-bg-blur" style={{ backgroundImage: `url('/images/fhome-oil-pour.jpg')` }}></div>
            <img src="/images/fhome-oil-pour.jpg" alt="F.home groundnut oil being poured" className="slide-photo" />
            <div className="overlay"></div>
            <div className="container">
              <div className="row slider-text justify-content-center align-items-center" data-scrollax-parent="true">
                <div className="col-sm-12 ftco-animate text-center">
                  <h1 className="mb-2">Farm Fresh, Delivered to Your Door</h1>
                  <h2 className="subheading mb-4">Best prices on pure, natural foods, every day</h2>
                  <p><a href="/shop" className="btn btn-primary">Shop Now</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Services Section */}
      <section className="ftco-section">
        <div className="container">
          <div className="row no-gutters ftco-services">
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-1 active d-flex justify-content-center align-items-center mb-2">
                  <FaTruck size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Free Shipping</h3>
                  <span>On order over ₹100</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-2 d-flex justify-content-center align-items-center mb-2">
                  <GiHoneyJar size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Always Fresh</h3>
                  <span>Product well package</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-3 d-flex justify-content-center align-items-center mb-2">
                  <FaMedal size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Superior Quality</h3>
                  <span>Quality Products</span>
                </div>
              </div>
            </div>
            <div className="col-md-3 text-center d-flex align-self-stretch ftco-animate">
              <div className="media block-6 services mb-md-0 mb-4">
                <div className="icon bg-color-4 d-flex justify-content-center align-items-center mb-2">
                  <MdSupportAgent size={30} color="#fff" />
                </div>
                <div className="media-body">
                  <h3 className="heading">Support</h3>
                  <span>24/7 Support</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Category Section */}
      {/* <section className="ftco-section ftco-category ftco-no-pt">
        <div className="container">
          <div className="row">
            {categories.length > 0 ? (
              categories.map((category) => {
                const name = category.Name ?? "Category";
                const slug = name.toLowerCase().replace(/\s+/g, "-");
                const imageUrl = category.ImageUrl ?? "/images/default-category.jpg";

                return (
                  <div key={category.CategorieId} className="col-6 col-sm-4 col-md-4 mb-4">
                    <div
                      className="category-wrap ftco-animate img d-flex align-items-end"
                      style={{
                        backgroundImage: `url('${imageUrl}')`,
                        minHeight: "200px",
                        borderRadius: "10px",
                        position: "relative",
                        overflow: "hidden",
                        cursor: "pointer",
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                      }}
                      onClick={() => navigate(`/shop?category=${slug}`)} // navigate to shop with category
                      role="button"
                      aria-label={`Open ${name} category`}
                    >
                      <div
                        className="text px-3 py-1"
                        style={{
                          background: "rgba(0,0,0,0.5)",
                          width: "100%",
                          textAlign: "center",
                          position: "absolute",
                          bottom: 0,
                        }}
                      >
                        <h2 className="mb-0 text-white">{name}</h2>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <p>Loading categories...</p>
            )}
          </div>
        </div>
      </section> */}
      {/* Featured Products Section */}
      <section className="ftco-section">
        <div className="container">
          <h3 className="mb-4">Our Products {queryParam}</h3>

          <div className="row g-2 g-md-3">
            {filteredProducts.length > 0 ? (
              filteredProducts.map((product) => (
                <div
                  key={product.productId}
                  className="col-6 col-md-4 col-lg-4 col-xl-3 mb-2 mb-md-3"
                >
                  <div className="card product-card text-center">
                    {/* IMAGE */}
                    <img
                      src={product.productImage ?? "/images/default-product.jpg"}
                      className="card-img-top"
                      alt={product.productName}
                      loading="lazy"
                      onClick={() =>
                        navigate(`/product-single/${product.productId}`)
                      }
                    />

                    <div className="card-body">
                      {/* NAME */}
                      <h6
                        className="product-title"
                        onClick={() =>
                          navigate(`/product-single/${product.productId}`)
                        }
                      >
                        {product.productName}
                      </h6>

                      {/* VARIANT */}
                      <select
                        className="form-control mb-2"
                        value={product.variant}
                        onChange={(e) =>
                          setFilteredProducts((prev) =>
                            prev.map((p) =>
                              p.productId === product.productId
                                ? { ...p, variant: e.target.value }
                                : p
                            )
                          )
                        }
                      >
                        {product.variants.map((v) => (
                          <option
                            key={v.variantId}
                            value={`${v.weight}${v.unit}`}
                          >
                            {v.weight}
                            {v.unit} - ₹{v.price}
                          </option>
                        ))}
                      </select>

                      {/* PRICE */}
                      <p className="price mb-2">
                        ₹
                        {
                          product.variants.find(
                            (v) =>
                              `${v.weight}${v.unit}` === product.variant
                          )?.price
                        }
                      </p>

                      {/* CART ACTION */}
                      {!product.inCart ? (
                        <button
                          className="btn btn-success w-100 add-cart-btn"
                          onClick={() => {
                            setFilteredProducts((prev) =>
                              prev.map((p) =>
                                p.productId === product.productId
                                  ? {
                                    ...p,
                                    inCart: true,
                                    quantity: 1,
                                  }
                                  : p
                              )
                            );
                            handleAddToCart(product);
                          }}
                        >
                          🛒 Add to Cart
                        </button>
                      ) : (
                        <div className="qty-box">
                          <button
                            className="qty-btn"
                            onClick={() =>
                              updateProductQuantity(product, product.quantity - 1)
                            }
                          >
                            −
                          </button>
                          <span className="qty-count">
                            {product.quantity}
                          </span>

                          <button
                            className="qty-btn"
                            onClick={() =>
                              updateProductQuantity(product, product.quantity + 1)
                            }
                          >
                            +
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p>No products found</p>
            )}
          </div>
        </div>
      </section>

      {/* Deal of the day section */}
      <section
        className="ftco-section img"
        style={{ backgroundImage: 'url("images/bg_3.jpg")' }}
      >
        <div className="container">

          <Swiper
            modules={[Autoplay, Pagination]}
            autoplay={{ delay: 4000 }}
            pagination={{ clickable: true }}
            loop
            spaceBetween={30}
          >

            {deals.map((deal) => (
              <SwiperSlide key={deal.id}>
                <div className="row justify-content-end">
                  <div className="col-md-6 heading-section deal-of-the-day">

                    <span className="subheading">Best Price For You</span>
                    <h2 className="mb-3">Deal of the day</h2>

                    <p>{deal.description}</p>
                    <h3 className="mb-2">{deal.title}</h3>

                    {/* PRODUCTS */}
                    <ul>
                      {deal.products.map((p) => (
                        <li key={p.id}>
                          {p.name} – ₹{p.price}
                        </li>
                      ))}
                    </ul>

                    {/* PRICE */}
                    <span className="price d-block mb-2">
                      <del className="text-muted">₹{deal.originalPrice}</del>
                      <span className="text-success ml-2">
                        ₹{deal.dealPrice}
                      </span>
                    </span>

                    {/* SAVE */}
                    <span className="badge badge-danger mb-2">
                      Save ₹{deal.savings}
                    </span>

                    {/* TIMER */}
                    <div className="mb-3">
                      <DealTimer endDate={deal.endTime} />
                    </div>

                    <button
                      className="btn btn-primary px-4 py-2"
                      onClick={() => handleDealBuyNow(deal)}
                    >
                      Buy Now
                    </button>


                  </div>
                </div>
              </SwiperSlide>
            ))}

          </Swiper>
        </div>
      </section>

      {/* Testimonials Carousel Section */}
      {SHOW_TESTIMONIALS && (
        <section className="ftco-section testimony-section">
          <div className="container">
            <div className="row justify-content-center mb-5 pb-3">
              <div className="col-md-7 heading-section ftco-animate text-center">
                <span className="subheading">Testimony</span>
                <h2 className="mb-4">Our satisfied customer says</h2>
                <p></p>
              </div>
            </div>
            <div className="row ftco-animate">
              <div className="col-md-12">
                {testimonials.length > 0 ? (
                  <Swiper
                    modules={[Autoplay, Pagination]}
                    autoplay={{ delay: 5000 }}
                    pagination={{ clickable: true }}
                    loop
                    spaceBetween={20}
                    slidesPerView={3}
                    breakpoints={{
                      320: {
                        slidesPerView: 1,
                        spaceBetween: 10
                      },
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 15
                      },
                      1024: {
                        slidesPerView: 3,
                        spaceBetween: 20
                      }
                    }}
                  >
                    {testimonials.map((item, index) => (
                      <SwiperSlide key={index}>
                        <div className="testimonial-card">
                          {/* USER IMAGE */}
                          <div
                            className="testimonial-img-square"
                            style={{
                              backgroundImage: `url(${baseURL + item.userImageUrl})`,
                              cursor: "pointer"
                            }}
                            onClick={() => setSelectedImage(baseURL + item.userImageUrl)}
                          />

                          {/* MESSAGE */}
                          <p className="testimonial-text">
                            "Excellent service and fresh products. Totally worth it!"
                          </p>

                          {/* NAME */}
                          <h6 className="testimonial-name">Happy Customer</h6>
                        </div>
                      </SwiperSlide>
                    ))}
                  </Swiper>
                ) : (
                  <div className="text-center p-5">
                    <p>Loading testimonials...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}
      <div>
        {/* Your routes or main layout */}
        <ToastContainer
          position="top-right"    // position of toast
          autoClose={3000}        // auto close in 3s
          hideProgressBar={false} // show/hide progress bar
          newestOnTop={false}
          closeOnClick
          pauseOnHover
          draggable
          theme="colored"         // optional: "light" | "dark" | "colored"
        />
      </div>
      {/* Newsletter Subscription Section */}
      <section className="ftco-section ftco-no-pt ftco-no-pb py-5 bg-light">
        <div className="container py-4">
          <div className="row d-flex justify-content-center py-5">
            <div className="col-md-6">
              <h2 style={{ fontSize: 22 }} className="mb-0">Subcribe to our Newsletter</h2>
              <span>Get e-mail updates about our latest shops and special offers</span>
            </div>
            <div className="col-md-6 d-flex align-items-center">
              <form onSubmit={handleSubscribe} className="subscribe-form">
                <div className="form-group d-flex">
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter email address"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <input type="submit" value="Subscribe" className="submit px-3" />
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/* Footer Section */}
      <Footer />
      <a
        href="https://wa.me/919148761750"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp size={40} color="#25D366" />
      </a>

      {/* IMAGE MODAL/POPUP */}
      {selectedImage && (
        <div 
          className="image-modal-backdrop"
          onClick={() => setSelectedImage(null)}
        >
          <div className="image-modal-content" onClick={(e) => e.stopPropagation()}>
            <button 
              className="image-modal-close"
              onClick={() => setSelectedImage(null)}
            >
              ✕
            </button>
            <img 
              src={selectedImage} 
              alt="Testimonial" 
              className="image-modal-img"
            />
          </div>
        </div>
      )}
    </div>
  );
};
export default Home;

